import React from "react";
import permissionsService from "../../services/permissionsService";

interface ShowIfHasAccessProps {
  requiredPermissions?: string[];
  children: React.ReactNode;
}

export default function ShowIfHasAccess({
  requiredPermissions = [],
  children,
}: ShowIfHasAccessProps) {
  const { hasPermission } = permissionsService();

  const permissionsPass =
    requiredPermissions.length === 0 ||
    requiredPermissions.some((perm) => hasPermission(perm));

  if (permissionsPass) {
    return <>{children}</>;
  }

  return null;
}
